module.exports = __webpack_public_path__ + "img/Multiple1.2b555539.png";